module.exports = __webpack_public_path__ + "img/independent_compensation_collection_accepted.098ce4d4.svg";